<template>
  <div class="bgc score">
    <Loading v-if="loading" />

    <div class="title">
      <div class="sort_son_title">
        {{ itemTitle }}
      </div>
      <div v-if="tableData && tableData.length">
        <a-button
          class="btn"
          style="margin-right: 15px"
          type="primary"
          ghost
          @click="importTo"
        >
          {{ $t('exam.downbtn') + itemTitle }}
        </a-button>
      </div>
    </div>
    <div class="table_div">
      <Table
        :columns="columns"
        :pagination="false"
        :data="tableData"
        @change="tableChange"
      />
      <div v-if="withoutPage.total > realSize" class="page-box">
        <a-pagination
          v-model="withoutPage.pageIndex"
          show-quick-jumper
          :hide-on-single-page="true"
          :default-page-size="realSize"
          :total="withoutPage.total"
          @change="onChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import axios, { getCookie } from '@utils'
  import ApiXy from '@lib/api.js'
  import Table from '@comp/tables/sortTable.vue'
  import Loading from '@comp/loading'

  export default {
    name: 'Stuansquenum',
    components: {
      Table,
      Loading
    },
    props: {
      itemTitle: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        loading: false,
        columns: [],
        tableData: [],
        // pagination: {
        //   hideOnSinglePage: true, //total无则一页故隐藏table分页
        //   pageSize: 10, //table条数(最小粒度呈现)
        //   total: 10 //total需<=于pageSize
        // },
        pageSize: 5, //请求条数(题号分页条数)
        withoutPage: {
          pageIndex: 1,
          pageSize: 10,
          total: 0
        },
        orderField: 'eqDisplayIndex',
        orderType: 'ascend',
        realSize: 10 //data一页长度(为解决传入数和返回数据数不一致)
      }
    },
    watch: {
      $route: {
        handler() {
          if (this.$route.query.classId || this.$route.query.seId) {
            this.getTable()
          }
        },
        deep: true
      }
    },
    created() {},
    mounted() {
      this.getTable()
    },
    methods: {
      // 表格排序
      tableChange(pagination, a, sort) {
        let { field, order } = sort
        if (order) {
          this.orderField = field
          this.orderType = order
        } else {
          this.orderField = ''
          this.orderType = ''
        }

        // this.pagination = { ...pagination }
        this.getTable(pagination.current)
      },
      // 表格分页
      onChange(pageIndex) {
        this.getTable(pageIndex)
      },
      //数据封装过滤
      dataFilter(data) {
        //copy data避免污染
        data = JSON.parse(JSON.stringify(data))
        let datas = []
        data.forEach(item => {
          let childData = JSON.parse(
            JSON.stringify(item.questionStudentDetailVos)
          )
          delete item.questionStudentDetailVos
          if (childData && childData.length) {
            childData = childData.filter(
              item =>
                item.errorStudentDetail != '无' ||
                item.errorStudentDetail != '無'
            )
            childData.forEach((itemc, indexc) => {
              let dataItem = {
                ...item,
                ...itemc,
                rowSpan: !indexc ? childData.length : 0
              }
              datas.push(dataItem)
            })
          } else {
            datas.push(item)
          }
        })
        return datas
      },

      // getstudentscoredetaillist
      //获取table数据  // 学生答题明细---新
      getTable(pageIndex = 1) {
        this.withoutPage.pageIndex = pageIndex //更新分页
        this.loading = true
        let {
          seId,
          meId,
          classId,
          dId,
          examIsActive = 1,
          campusId
        } = this.$route.query
        let params = {
          seId,
          meId,
          classId,
          dId,
          pageSize: this.pageSize,
          pageIndex,
          campusId
        }
        let unionUrl = [
          'getstudentscoredetaillist',
          'getstudentscoredetaillistUnion',
          'getstudentscoredetaillistSchoolUnion'
        ]
        let url = unionUrl[examIsActive]
        axios({
          url,
          params,
          loading: false
        })
          .then(res => {
            this.loading = false
            this.tableData = []
            if (res.status) {
              // this.realSize = res.data.length
              // this.withoutPage.total = res.total

              this.columns = res.data.title.map((item, index) => {
                let obj = {
                  title: item,
                  dataIndex: index,
                  width:
                    item == '错误学生名单' || item == '錯誤學生名單'
                      ? 300
                      : 100,
                  ellipsis: false
                }
                return obj
              })
              res.data.question.forEach(item => {
                let itemobj = {}
                item.forEach((col, i) => {
                  if (Array.isArray(col)) {
                    col = col.toString()
                  }
                  itemobj[i] = col
                })
                this.tableData.push(itemobj)
              })
              // this.dataRender(this.dataFilter(res.data.question))
            } else {
              this.tableData = []
            }
          })
          .catch(() => {
            setTimeout(() => {
              this.loading = false
            }, 200)
          })
      },

      importTo() {
        let {
          meId,
          seId,
          dId,
          classId,
          examIsActive = 1,
          campusId
        } = this.$route.query
        let unionUrl = [
          'exportstudentscoredetaillistdownload',
          'exportstudentscoredetaillistdownloadUnion',
          'exportstudentscoredetaillistdownloadSchoolUnion'
        ]
        let union = unionUrl[examIsActive]
        let api = ApiXy.defaulteApi.path[union]
        let url = ''
        let str = examIsActive == 1 ? '' : `&classId=${classId}`
        url =
          `${ApiXy.defaulteApi.host}` +
          `${api}` +
          `?campusId=${campusId}&seId=${seId}&meId=${meId}&dId=${dId}${str}` +
          '&X-ZYLX-TOKEN=' +
          getCookie('X-ZYLX-TOKEN')
        window.open(url, '_blank', '')
      }
      // importZip() {
      //   let url =
      //     `${ApiXy.defaulteApi.host}` +
      //     `${ApiXy.defaulteApi.path.studentscoredetaillistzip}` +
      //     `?userId=${this.$store.state.userInfo.userId}` +
      //     `&authId=${this.$route.query.authId}` +
      //     `&seId=${this.$route.query.seId}` +
      //     `&classId=${this.$route.query.classId}` +
      //     `&apiorderField=${this.orderField}` +
      //     `&orderType=${this.orderType.replace('end', '')}` +
      //     '&X-ZYLX-TOKEN=' +
      //     getCookie('X-ZYLX-TOKEN')
      //   window.open(url, '_blank', '')
      // }
    }
  }
</script>
<style lang="less" scoped>
  .score {
    height: 100%;
    background: #fff;
    .left {
      float: left;
    }
    .right {
      float: right;
    }
    .title {
      // height: 58px;
      // line-height: 58px;
      // font-size: 16px;
      // color: rgba(0, 0, 0, 0.85);
      // margin-top: -50px;
      .left_div {
        margin-left: 24px;
      }
      .right_div {
        margin-right: 24px;
        .btn {
          margin-left: 12px;
        }
      }
    }
    .table_div {
      height: calc(100% - 58px);
      padding: 0 20px;
      /deep/ .ant-table-body {
        border-top: 1px solid #e8e8e8;
        border-bottom: 1px solid #e8e8e8;
        // max-height: 55vh;
        overflow-y: auto;
        &:hover::-webkit-scrollbar-thumb {
          visibility: visible;
        }
      }
      /deep/ .ant-table-body {
        table {
          border-top: 0;
        }
      }
    }
  }
  .page-box {
    padding: 30px 10px 10px;
    text-align: center;
  }
</style>
